const MINIO_BASE_URL = 'https://dosya.atmturkiye.com';
const MINIO_MARKERS_BUCKET = 'atmpoint';
const MINIO_MARKERS_FOLDER = 'markers';

function normalizeName(text) {
  if (!text) return '';
  return text
    .toString()
    .replace(/[ıİ]/g, 'i')
    .replace(/[şŞ]/g, 's')
    .replace(/[çÇ]/g, 'c')
    .replace(/[ğĞ]/g, 'g')
    .replace(/[öÖ]/g, 'o')
    .replace(/[üÜ]/g, 'u')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, 've')
    .replace(/[^a-z0-9]/g, '');
}

const bankAliases = {
  akbank: 'akbank',
  albaraka: 'albaraka',
  denizbank: 'deniz',
  finansbank: 'finans',
  garanti: 'garanti',
  garantibbva: 'garanti',
  halkbank: 'halk',
  hsbc: 'hbsc',
  ing: 'ing',
  ingbank: 'ing',
  isbank: 'is',
  isbankasi: 'is',
  kuveytturk: 'kuveyt',
  kuveyt: 'kuveyt',
  odeabank: 'odeabank',
  ptt: 'ptt',
  qnbfinansbank: 'qnb',
  qnb: 'qnb',
  sekerbank: 'sekerbank',
  teb: 'teb',
  vakifbank: 'vakif',
  vakfbank: 'vakif',
  yapikredi: 'yapikredi',
  yapkredi: 'yapikredi',
  ziraat: 'ziraat',
  ziraatbankasi: 'ziraat',
  ziraatbankası: 'ziraat',
  ziraatbankas: 'ziraat',
};

export function getMarkerImage(bankName, width = 620, height = 420, quality = 70) {
  if (!bankName) return null;
  
  const normalized = normalizeName(bankName);
  const bankKey = bankAliases[normalized] || normalized;
  const filename = `${bankKey}.png`;
  
  return `${MINIO_BASE_URL}/${MINIO_MARKERS_BUCKET}/${MINIO_MARKERS_FOLDER}/${filename}/rs:fill:${width}:${height}/q:${quality}`;
}
